import { apiFetch, parseJson } from "./client";
import type { PlaceSuggestion } from "./types";

export type PlaceGeocode = {
  lat: number;
  lon: number;
};

export async function geocodePlace(query: string): Promise<PlaceGeocode> {
  const params = new URLSearchParams({ q: query });
  return parseJson<PlaceGeocode>(
    await apiFetch(`/api/places/geocode?${params}`)
  );
}

export async function searchPlaces(query: string): Promise<PlaceSuggestion[]> {
  const params = new URLSearchParams({ q: query });
  return parseJson<PlaceSuggestion[]>(
    await apiFetch(`/api/places/search?${params}`)
  );
}
